// @core/api/endpoints/workflow/submit_decision.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PendingDecisionResponse,
  SubmitDecisionRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Submit decision
 * Records an approver's verdict on a human task. Once the node's approval policy is satisfied the parked execution continues.
 */
export async function SubmitDecision(
  decision_id: string,
  data: SubmitDecisionRequest,
  options?: RequestOptions
): Promise<PendingDecisionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/decisions/:decision_id/submit`;
  requestPath = requestPath.replace(':decision_id', encodeURIComponent(decision_id));
  const requestOptions = options;
  return client.post<PendingDecisionResponse>(requestPath, data, requestOptions);
}
